// Empty string = same origin (use with IIS reverse proxy on /api).
const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL !== undefined
    ? process.env.REACT_APP_API_BASE_URL
    : 'http://localhost:5244';

async function request(path, { method = 'GET', body } = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  let payload = null;
  try {
    payload = await response.json();
  } catch {
    payload = null;
  }

  if (!response.ok) {
    const message = payload?.message || `Request failed with status ${response.status}`;
    throw new Error(message);
  }

  return payload?.data;
}

export const publicApi = {
  getHeroSections: () => request('/api/hero-sections'),
  getAboutCompany: () => request('/api/about-company'),
  getServices: () => request('/api/services'),
  getServiceOverviews: () => request('/api/service-overviews'),
  getPortfolioOverviews: () => request('/api/portfolio-overviews'),
  getProjects: () => request('/api/projects'),
  getTestimonials: () => request('/api/testimonials'),
  getPartners: () => request('/api/partners'),
  getWhyChooseUsCards: () => request('/api/faqs'),
  getDomainExtensions: () => request('/api/domain-extensions'),
  getFooterContent: () => request('/api/footer-content'),
  getContactInformation: () => request('/api/contact-information'),
  getWebsiteSections: () => request('/api/website-sections'),
  sendMessage: (message) =>
    request('/api/messages/public', {
      method: 'POST',
      body: message,
    }),
};
